export default {
    asset_import_instructions: 'Important Note: The ID column is mandatory. If the import process is intended for updating existing records, perform a table export without editing the ID column value to maintain record reference. If you want to create new Assets, leave the ID column blank. Tags should be separated by a "/" character. For example: Tag1/Tag2/Tag3.',
    importAssets_title: 'Import Assets',
    importAssets_button: 'Import',
    importAssets_cancel: 'Cancel',
    importAssets_semicolon: 'Semicolon (;)',
    importAssets_comma: 'Comma (,)',
    importAssets_selectDelimiter: 'Select',
    importAssets_delimiter: 'Delimiter',
    importAssets_started: 'Import started successfully',
    importAssets_title: 'Assets Import',
    importAssets_error_required: 'File is required',
    importAssets_error_delimiter: 'Delimiter is required',
    importAssets_downloadTemplate: 'Download Template',
    importAssets_file: 'File',
    importAssets_chooseFile: 'Choose File',
    importAssets_support_message: 'Only CSV format supported',
    importAssets_max: 'Max',
    importAssets_maxSizeFile: 'Maximum file size: 5MB',

    importAssets_template_id: 'Asset ID',
    importAssets_template_label: 'Label',
    importAssets_template_type: 'Asset Type',
    importAssets_template_subtype: 'Asset Subtype',
    importAssets_template_externalId: 'External ID',
    importAssets_template_vin: 'VIN',
    importAssets_template_InspectionDeviceType: 'Inspection Device Type',
    importAssets_template_status: 'Status',
    importAssets_template_tags: 'Tags',
    importAssets_template_make: 'Make',
    importAssets_template_model: 'Model',
    importAssets_template_year: 'Year',
    importAssets_template_InspectionTagId: 'Inspection Tag ID',
    importAssets_template_powerUnitNumber: 'Power Unit Number',
    importAssets_template_maintenanceCompany: 'Maintenance Company',
    importAssets_template_registrationCountry: 'Registration Country',
    importAssets_template_registrationState: 'Registration State',
    importAssets_template_registrationExpiration: 'Registration Expiration',
    importAssets_template_engineSerialNumber: 'Engine Serial Number',
    importAssets_template_chassisSerialNumber: 'Chassis Serial Number',
    importAssets_template_licensePlate: 'License Plate',

    assets_import_error_CA01: 'Empty CSV file: The file contains no data rows. Please add at least one row with asset information.',
    assets_import_error_CA02: 'Error in CSV format: Asset ID column is required for asset updates.',
    assets_import_error_CA03: 'No valid data rows found: Asset ID and Label columns cannot be empty in all rows.',
    assets_import_error_CA04: 'Error in CSV format: Asset Type column is required for asset updates.',
    assets_import_error_CA05: 'Error in CSV format: Asset Subtype column is required for asset updates.',
};